<script>
	import CartProduct from '$lib/components/CartProduct.svelte';
	import { goto } from '$app/navigation';

	import check from '$lib/images/check.svg';
	import { page } from '$app/stores';
	import { clickOutside } from '$lib/utils/click_outside.js';
	import { variables } from '$lib/variables';
	import Loader from '$lib/components/Loader.svelte';
	import { lang } from '$lib/translations/category/index.js';
	import PopularMes from '$lib/components/PopularMes.svelte';
	export let data;

	async function OnGetNewPage() {
		load = true;
		let url = data.products.next;

		url = `${url}`;
		const res = await fetch(url);

		let results = await res.json();
		data.products.results.products = [
			...data.products.results.products,
			...results.results.products
		];
		data.products.next = results.next;

		load = false;
	}

	let load = false;

	$: innerWidth = 0;
</script>

<svelte:head>
	<title
		>Iloveitalianbags - Товары для Джентльменов из Италии.Сумки.Аксессуары и многое другое.</title
	>
	<meta
		name="description"
		content="Товары для Джентльменов из Италии.Сумки.Аксессуары и многое другое. Только оригинальная продукция. Быстрая доставка. Свыше 2000 моделей сумок, ремней, обуви из Италии."
	/>
	<meta
		data-n-head="ssr"
		data-hid="og:description"
		property="og:description"
		content="Товары для Джентльменов из Италии.Сумки.Аксессуары и многое другое.Только оригинальная продукция. Быстрая доставка. Свыше 2000 моделей сумок, ремней, обуви из Италии."
	/>
	<meta
		data-n-head="ssr"
		data-hid="og:description"
		name="og:description"
		content="Товары для Джентльменов из Италии.Сумки.Аксессуары и многое другое. Только оригинальная продукция. Быстрая доставка. Свыше 2000 моделей сумок, ремней, обуви из Италии."
	/>
	<meta
		data-n-head="ssr"
		data-hid="og:title"
		property="og:title"
		content="Iloveitalianbags - Товары для Джентльменов из Италии.Сумки.Аксессуары и многое другое"
	/>
	<meta
		data-n-head="ssr"
		data-hid="og:title"
		name="og:title"
		content="Iloveitalianbags - Товары для Джентльменов из Италии.Сумки.Аксессуары и многое другое"
	/>
	<meta
		name="og:description"
		content="Товары для Джентльменов из Италии.Сумки.Аксессуары и многое другое.Только оригинальная продукция. Быстрая доставка. Свыше 2000 моделей сумок, ремней, обуви из Италии."
	/>
	<meta
		data-n-head="ssr"
		data-hid="og:url"
		name="og:url"
		content={`https://iloveitalianbags.ru/gentlemen-products`}
	/>
	<meta
		data-n-head="ssr"
		data-hid="og:image:alt"
		property="og:image:alt"
		content="https://iloveitalianbags.ru/biagini.jpg"
	/>
	<meta
		data-n-head="ssr"
		data-hid="og:image:secure_url"
		property="og:image:secure_url"
		content="https://iloveitalianbags.ru/biagini.jpg"
	/>

	<link rel="canonical" href={`https://iloveitalianbags.ru/gentlemen-products`} />
</svelte:head>
<svelte:window bind:innerWidth />

{#if load}
	<Loader />
{/if}

<div
	class="bg-cover bg-center md:h-[100vh] h-[60vh] md:mt-0 mt-14 bg-no-repeat flex justify-center items-center"
	style="background-image: url(/gentel.avif);"
>
	<div class="flex flex-col justify-center items-center">
		<h1 class="text-[24px] md:text-[48px] text-custom-white-bg text-center">
			{#if $page.data.host === 'ARM'}
				Товары для Джентльменов {lang[$page.data.host]['izitaly']}
			{:else}
				Товары для Джентльменов {lang[$page.data.host]['izitaly']}
			{/if}
		</h1>
		<p class="md:text-xl text-[16px] px-[2em] md:px-1 mt-[7px] text-custom-white-bg text-center">
			Made in Italy 100%
		</p>
	</div>
</div>

<!-- PRODUCTS -->
{#if $page.data.products}
	{#if data.products.results.products.length > 0}
		<div
			class="grid observer-filter-products mt-[2px] min-h-screen grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[2px]"
		>
			{#each data.products.results.products as item, ind (item.id)}
				<CartProduct {item} {ind} />
			{/each}
		</div>
	{:else}
		<h2 class="w-full text-center text-custom-gray text-2xl">
			{#if !load}
				Ничего не найдено
			{/if}
		</h2>
	{/if}

	<div class="h-[20vh] pb-10 pt-10 flex justify-center">
		{#if data.products.next}
			<button
				style="border: 2px solid #000000;"
				class="text-base text-custom-black h-max w-max py-[20px] md:py-[14px] md:px-[32px] px-[20px] flex justify-center items-center"
				on:click={() => {
					OnGetNewPage();
				}}
			>
				{lang[$page.data.host]['seeAll']}
			</button>
		{/if}
	</div>
{/if}
<PopularMes />
